import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import router from './router'
import store from './store'
import 'nprogress/nprogress.css' // progress bar style
import { getToken, getFirstCommunityId, getRoutesCut, removeToken, getCurrentOrganizationId } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { defaultValuePath } from '@/utils/whiteList'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = new Set(['/login', '/mobilePage', '/error', '/play/wasm']) // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (defaultValuePath.includes(to.path)) {
      // 跳转路由时判断默认选中的项目id是否跟保存的项目数组第一个数据一致
      const firstCommunityId = store.getters.firstCommunityId || getFirstCommunityId('firstCommunityId')
      const searchCommunities = store.getters.companyPermissionCommunityLists
      if (searchCommunities && firstCommunityId && firstCommunityId !== searchCommunities[0].communityId) {
        store.dispatch('user/getPermissionCommunityList', { isFirst: true, organizationId: getCurrentOrganizationId() || store.getters.currentOrganizationId })
      }
    }
    if (to.path === '/login' || to.path === '/error') {
      // if is logged in, redirect to the home page
      next({ path: '/welcome/welcome' })
      NProgress.done()
    } else {
      const hasGetUserInfo = store.getters.mobilePhone
      if (hasGetUserInfo) {
        next()
      } else {
        try {
          await store.dispatch('user/getInfo')
          await store.dispatch('user/getTenantTypeBy')

          // setRoutesCut(0);
          // if (store.getters.organizationInfo.organizationType !== 2) await store.dispatch('user/getPermissionCommunityList')
          let accessRoutes = await store.dispatch('permission/generateRoutes', getRoutesCut('routesCut') || 0)
          if (!accessRoutes.length) {
            removeToken()
            if (from.path !== '/login') next('/login')
            NProgress.done()
            return Message({
              message: '暂无权限，请联系管理员授权后登录',
              type: 'error',
              duration: 2 * 1000,
            })
          }
          router.addRoutes(accessRoutes)
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next('/login')
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.has(to.path)) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      // `/login?redirect=${to.path}`
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
